import React from 'react'
import { StatusBadge } from './StatusBadge.jsx'

function relativeTime(iso) {
  if (!iso) return 'Never'
  const diff = Date.now() - new Date(iso).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `${hrs}h ago`
  const days = Math.floor(hrs / 24)
  return `${days}d ago`
}

export function UserTable({ users, onRowClick }) {
  if (!users || users.length === 0) {
    return <div style={styles.empty}>No users found.</div>
  }

  return (
    <table style={styles.table}>
      <thead>
        <tr>
          <th style={styles.th}>Name</th>
          <th style={styles.th}>Email</th>
          <th style={styles.th}>Manager</th>
          <th style={styles.th}>Team</th>
          <th style={styles.th}>Sessions</th>
          <th style={styles.th}>Last active</th>
          <th style={styles.th}>Status</th>
        </tr>
      </thead>
      <tbody>
        {users.map((user) => (
          <tr
            key={user.userId}
            style={styles.row}
            onClick={() => onRowClick && onRowClick(user)}
          >
            <td style={styles.td}>{user.name || '—'}</td>
            <td style={{ ...styles.td, color: 'var(--text-secondary)' }}>{user.email}</td>
            <td style={styles.td}>{user.managerName || '—'}</td>
            <td style={styles.td}>{user.team || '—'}</td>
            <td style={styles.td}>{user.totalSessions ?? 0}</td>
            <td style={{ ...styles.td, color: 'var(--text-secondary)' }}>
              {relativeTime(user.lastActiveAt)}
            </td>
            <td style={styles.td}>
              <StatusBadge status={user.status} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

const styles = {
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 12,
  },
  th: {
    textAlign: 'left',
    padding: '6px 10px',
    color: 'var(--text-secondary)',
    fontWeight: 500,
    borderBottom: '1px solid var(--border)',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '8px 10px',
    borderBottom: '0.5px solid var(--border)',
    verticalAlign: 'middle',
  },
  row: {
    cursor: 'pointer',
    transition: 'background var(--duration-fast) ease',
  },
  empty: {
    fontSize: 12,
    color: 'var(--text-secondary)',
    padding: '20px 0',
  },
}
